<template>
    <MainTemplate></MainTemplate>
</template>
<script>
import MainTemplate from '../templates/MainTemplate'
import paymentTypes from "@/constants/paymentTypes";

export default {
    name: 'MainPage',
    inject: ['$validator'],
    components: {
        MainTemplate
    },
    created () {
      let query = { ...this.$route.query };

      if (undefined === query.payment_type) {
        return;
      }

      const routeName = this.getPaymentMethodRouteName(query.payment_type);

      if (null === routeName) {
        return;
      }
      const route = this.$router.resolve({ name: routeName });

      delete query.payment_type;

      let path = route.route.path;
      if (!path.endsWith('/')) {
        path += '/';
      }

      this.$router.push({path, query})
    },
  methods: {
      getPaymentMethodRouteName(paymentMethod) {
        switch (paymentMethod) {
          case paymentTypes.SUBSCRIPTION:
            return 'MonthlyPaymentStepOne';
          case paymentTypes.SINGLE:
            return 'OneTimePaymentStepOne';
        }

        return null;
      }
  }
}
</script>
